module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Gd-Ha-Ia.b2fed1e7.png";